import './App.css';
import Left from '../Left/Left';
import Right from '../Right/Right';

function App() {
  return (
    <div className="App">
      <Left />
      <Right />
    </div>
  );
}

export default App;
